import { render, staticRenderFns } from "./CreateBackupDialog.vue?vue&type=template&id=63673d44"
import script from "./CreateBackupDialog.vue?vue&type=script&lang=js"
export * from "./CreateBackupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports